import Directory from "../../compoments/directory/directory.component";

const Home = () => {
  return (
    <div>
      <Directory />
    </div>
  );
};

export default Home;
